import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/css/iconfont.css";
import api from "@/api/index";
import mixins from "@/mixins/index.js";
import dayjs from "dayjs";
import toExcel from "./utils/previewExcel";
import VerifyCode from "@/components/VerifyCode/VerifyCode.vue";
import * as filters from "./filters";
import hevueImgPreview from "hevue-img-preview";
import "hevue-img-preview/css/theme-dark.css";

import Print from "@/utils/print";
import "@/assets/css/global.styl";
import "@/assets/css/global-widget.styl";
import "view-design/dist/styles/iview.css";

import VideoPlayer from "vue-video-player";
Vue.use(VideoPlayer); //视频

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

Vue.config.productionTip = false;
Vue.prototype.$dayjs = dayjs;
Vue.prototype.$api = api;
Vue.prototype.$toExcel = toExcel;

Vue.use(Print);

Vue.use(hevueImgPreview);
Vue.use(ElementUI);
Vue.mixin(mixins);

// 注册全局验证码组件
Vue.component("VerifyCode", VerifyCode);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
